import { Directive, forwardRef, Input } from '@angular/core';
import { AsyncValidator, AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { catchError, map, debounceTime, distinctUntilChanged, switchMap, first } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { _HttpClient } from '@delon/theme';

@Directive({
  selector: '[appValidateName]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => ValidateNameDirective),
      multi: true,
    },
  ],
})
export class ValidateNameDirective implements AsyncValidator {
  @Input() vparam: any;

  constructor(public http: _HttpClient) {}

  validate(ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return ctrl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(() =>
        this.http.get(this.vparam.url + `?name=${ctrl.value}` + (this.vparam.id > 0 ? `&id=${this.vparam.id}` : '')),
      ),
      map(res => {
        return res.status === 0 && res.data === true ? { duplicated: true } : null;
      }),
      catchError(res => null),
      first(),
    );
  }
}
// URLS.bizTypeNameValidate
